import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Article from './article';
import HotSpots from './hotSpots';
import NewFooter from './newFooter';
import { getRecommend, getRelateFeedList } from '../../../../services/api';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        data: [],
        scrollElement: null,
        hotPage: 0,
        isReturn: false,
        initY: 0,
        hotNewsData: [],
        recommendArticles: [],
        hotArticles: [],
    };

    hotBox = React.createRef();

    arrayPropertyUnique = (arr = [], uniId = '') => {
        const obj = {};
        const tempArr = [];

        for (let i = 0; i < arr.length; i++) {
            if (!obj[arr[i][uniId]]) {
                tempArr.push(arr[i]);
                if (arr[i][uniId]) {
                    obj[arr[i][uniId]] = true;
                }
            }
        }

        return tempArr;
    };

    async componentDidMount() {
        const { hotPage } = this.state;
        const {
            content: {
                docData: { searchPath },
                recommendDefault,
                fiction,
                relatedRecommend = [],
                isHitBlack,
                isCloseAlgRec,
                hotNews,
            },
        } = this.props;

        let data = [];
        const recommands = hotNews || [];

        let relateData = [];

        try {
            data = await getRecommend(hotPage, 'seo');

            if (fiction[1]) {
                data.splice(1, 0, fiction[1]);
            }
        } catch (e) {
            console.error(e);
        }

        try {
            if (relatedRecommend.length > 0) {
                relateData = await getRelateFeedList(relatedRecommend);
            }
        } catch (e) {
            console.error(e);
        }
        let recommendArticles = [];
        const hotNewsData = recommands.slice(0, 2);
        const recommendDate = recommands.slice(2, 4);
        const hotArticles = recommands.slice(4);

        if (isHitBlack || isCloseAlgRec) {
            recommendArticles = relateData;
        } else {
            recommendArticles = relateData.concat(recommendDate);
        }
        recommendArticles = this.arrayPropertyUnique(recommendArticles, 'base62Id');

        if (fiction[0]) {
            hotArticles.splice(2, 0, fiction[0]);
        }

        this.setState({
            data,
            hotNewsData,
            recommendArticles,
            hotArticles,
        });
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    render() {
        const { hotPage, hotNewsData, recommendArticles, hotArticles } = this.state;
        const { data } = this.state;
        const {
            content: {
                docData,
                comment,
                bottomNav,
                nav,
                sharePPX,
                topAd,
                infoAd0,
                infoAd1,
                infoAd2,
                bannerAd,
                articleAd,
                recommendAd,
                unfoldType,
                articleUnfoldLayer,
                isHitBlack,
                isCloseAlgRec,
                hasCopyRight,
                articleBottomAd,
                interact,
                sourceReason,
                textListAd,
                cutoffGray,
                createTime,
            },
        } = this.props;

        const infoAd = {
            topAd,
            infoAd0,
            infoAd1,
            infoAd2,
            bannerAd,
            articleBottomAd,
        };

        return (
            <div className={styles.main}>
                <div className={styles.content}>
                    <Article
                        docData={docData}
                        comment={comment}
                        hotNews={hotNewsData}
                        recommendArticles={recommendArticles}
                        isCloseAlgRec={isCloseAlgRec}
                        topAd={topAd}
                        ad={infoAd}
                        sharePPX={sharePPX}
                        unfoldType={unfoldType}
                        articleUnfoldLayer={articleUnfoldLayer}
                        isHitBlack={isHitBlack}
                        hasCopyRight={hasCopyRight}
                        interact={interact}
                        sourceReason={sourceReason}
                        textListAd={textListAd}
                        cutoffGray={cutoffGray}
                        createTime={createTime}
                    />
                    {!isHitBlack && (
                        <HotSpots
                            data={data}
                            hotArticles={hotArticles}
                            articleAd={articleAd}
                            recommendAd={recommendAd}
                        />
                    )}
                </div>
                {!isHitBlack && hotPage === 12 ? <NewFooter bottomNav={bottomNav} content={nav} /> : ''}
            </div>
        );
    }
}

export default errorBoundary(Content);
